import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import { referralSchema, ReferralFormValues } from "@modules/partners/validations";
import { useCreateReferralMutation } from "@modules/partners/services/mutations";

export function useReferralCreateForm() {
  const { mutateAsync, isPending } = useCreateReferralMutation();

  const methods = useForm<ReferralFormValues>({
    resolver: zodResolver(referralSchema()),
    mode: "onBlur",
  });

  const { handleSubmit } = methods;

  return {
    methods,
    isPending,
    handleSubmit,
    mutateAsync,
  };
}
